import { loadTranslations } from '@angular/localize';

// Thai is the source locale, so it needs no translation map and pays no cost here.
// English must load before bootstrap: i18n markers resolve at render time, outside the
// reactive graph, so switching locale is a page reload rather than a live update.
if (localStorage.getItem('preferredLanguage') === 'en') {
  const messages = await import('./locale/messages.en.json');
  loadTranslations(messages.default.translations as Record<string, string>);
  $localize.locale = 'en';
  document.documentElement.lang = 'en';
}

// The app is imported only NOW (#1152). A `$localize` at module level (a label map, a constant) is evaluated when its
// module loads, and a static import at the top of this file loads every eager module before the block above has run, so
// those labels stayed Thai in English mode whatever the marker said. Thai mode takes the same path with nothing to load
// first; the one cost, in both modes, is that the app's chunks are requested after this file instead of beside it.
const [{ bootstrapApplication }, { appConfig }, { App }] = await Promise.all([
  import('@angular/platform-browser'),
  import('./app/app.config'),
  import('./app/app'),
]);

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
